const d3 = Object.assign({},
    require("d3-selection"),
    require("d3-time-format")
);



export default class makeChart {
    constructor(opts) {
        Object.assign(this, opts);
        this.aspectHeight = opts.aspectHeight ? opts.aspectHeight : .68;
        this.appendElements();
        //this.update();
    }

    update() {
        //this._setDimensions();
        //this._setScales();
        this.render();
    }

    appendElements() {

        let sel = d3.select(this.element)

        sel.append('img')
            .attr("src", `img/${this.data.slug}_sm.jpg`);

        sel.append('p')
            .html(this.data.titleText);

        sel.on('click', ()=> {
            window.open(`${this.data.url}`,'_blank');
        });

    }

    render() {

    }
}
